import { c as _c } from "react/compiler-runtime";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { CheckIcon, ChevronRightIcon, DotFilledIcon } from "@radix-ui/react-icons";
import * as React from "react";
import { cn } from "#/lib/utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DropdownMenu = DropdownMenuPrimitive.Root;
const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
const DropdownMenuGroup = DropdownMenuPrimitive.Group;
const DropdownMenuPortal = DropdownMenuPrimitive.Portal;
const DropdownMenuSub = DropdownMenuPrimitive.Sub;
const DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;
const DropdownMenuSubTrigger = /*#__PURE__*/React.forwardRef((t0, ref) => {
  const $ = _c(14);
  let children;
  let className;
  let inset;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      inset,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = inset;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    inset = $[3];
    props = $[4];
  }
  const t1 = inset && "pl-8";
  let t2;
  if ($[5] !== className || $[6] !== t1) {
    t2 = cn("focus:bg-accent data-[state=open]:bg-accent flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", t1, className);
    $[5] = className;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(ChevronRightIcon, {
      className: "ml-auto"
    });
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== props || $[11] !== ref || $[12] !== t2) {
    t4 = /*#__PURE__*/_jsxs(DropdownMenuPrimitive.SubTrigger, {
      ref: ref,
      className: t2,
      ...props,
      children: [children, t3]
    });
    $[9] = children;
    $[10] = props;
    $[11] = ref;
    $[12] = t2;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
});
DropdownMenuSubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
const DropdownMenuSubContent = /*#__PURE__*/React.forwardRef((t0, ref) => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] overflow-hidden rounded-md border p-1 shadow-lg", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== ref || $[7] !== t1) {
    t2 = /*#__PURE__*/_jsx(DropdownMenuPrimitive.SubContent, {
      ref: ref,
      className: t1,
      ...props
    });
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});
DropdownMenuSubContent.displayName = DropdownMenuPrimitive.SubContent.displayName;
const DropdownMenuContent = /*#__PURE__*/React.forwardRef((t0, ref) => {
  const $ = _c(11);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      sideOffset: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const sideOffset = t1 === undefined ? 4 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] overflow-hidden rounded-md border p-1 shadow-md", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== ref || $[8] !== sideOffset || $[9] !== t2) {
    t3 = /*#__PURE__*/_jsx(DropdownMenuPrimitive.Portal, {
      children: /*#__PURE__*/_jsx(DropdownMenuPrimitive.Content, {
        ref: ref,
        sideOffset: sideOffset,
        className: t2,
        ...props
      })
    });
    $[6] = props;
    $[7] = ref;
    $[8] = sideOffset;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
});
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;
const DropdownMenuItem = /*#__PURE__*/React.forwardRef((t0, ref) => {
  const $ = _c(11);
  let className;
  let inset;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      inset,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = inset;
    $[3] = props;
  } else {
    className = $[1];
    inset = $[2];
    props = $[3];
  }
  const t1 = inset && "pl-8";
  let t2;
  if ($[4] !== className || $[5] !== t1) {
    t2 = cn("focus:bg-accent focus:text-accent-foreground relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", t1, className);
    $[4] = className;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== ref || $[9] !== t2) {
    t3 = /*#__PURE__*/_jsx(DropdownMenuPrimitive.Item, {
      ref: ref,
      className: t2,
      ...props
    });
    $[7] = props;
    $[8] = ref;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
});
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
const DropdownMenuCheckboxItem = /*#__PURE__*/React.forwardRef((t0, ref) => {
  const $ = _c(14);
  let checked;
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      checked,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = children;
    $[3] = className;
    $[4] = props;
  } else {
    checked = $[1];
    children = $[2];
    className = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("focus:bg-accent focus:text-accent-foreground relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx("span", {
      className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
      children: /*#__PURE__*/_jsx(DropdownMenuPrimitive.ItemIndicator, {
        children: /*#__PURE__*/_jsx(CheckIcon, {
          className: "h-4 w-4"
        })
      })
    });
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== checked || $[9] !== children || $[10] !== props || $[11] !== ref || $[12] !== t1) {
    t3 = /*#__PURE__*/_jsxs(DropdownMenuPrimitive.CheckboxItem, {
      ref: ref,
      className: t1,
      checked: checked,
      ...props,
      children: [t2, children]
    });
    $[8] = checked;
    $[9] = children;
    $[10] = props;
    $[11] = ref;
    $[12] = t1;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
});
DropdownMenuCheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
const DropdownMenuRadioItem = /*#__PURE__*/React.forwardRef((t0, ref) => {
  const $ = _c(12);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("focus:bg-accent focus:text-accent-foreground relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx("span", {
      className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
      children: /*#__PURE__*/_jsx(DropdownMenuPrimitive.ItemIndicator, {
        children: /*#__PURE__*/_jsx(DotFilledIcon, {
          className: "h-2 w-2 fill-current"
        })
      })
    });
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== props || $[9] !== ref || $[10] !== t1) {
    t3 = /*#__PURE__*/_jsxs(DropdownMenuPrimitive.RadioItem, {
      ref: ref,
      className: t1,
      ...props,
      children: [t2, children]
    });
    $[7] = children;
    $[8] = props;
    $[9] = ref;
    $[10] = t1;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
});
DropdownMenuRadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;
const DropdownMenuLabel = /*#__PURE__*/React.forwardRef((t0, ref) => {
  const $ = _c(11);
  let className;
  let inset;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      inset,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = inset;
    $[3] = props;
  } else {
    className = $[1];
    inset = $[2];
    props = $[3];
  }
  const t1 = inset && "pl-8";
  let t2;
  if ($[4] !== className || $[5] !== t1) {
    t2 = cn("px-2 py-1.5 text-sm font-semibold", t1, className);
    $[4] = className;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== ref || $[9] !== t2) {
    t3 = /*#__PURE__*/_jsx(DropdownMenuPrimitive.Label, {
      ref: ref,
      className: t2,
      ...props
    });
    $[7] = props;
    $[8] = ref;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
});
DropdownMenuLabel.displayName = DropdownMenuPrimitive.Label.displayName;
const DropdownMenuSeparator = /*#__PURE__*/React.forwardRef((t0, ref) => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("bg-muted -mx-1 my-1 h-px", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== ref || $[7] !== t1) {
    t2 = /*#__PURE__*/_jsx(DropdownMenuPrimitive.Separator, {
      ref: ref,
      className: t1,
      ...props
    });
    $[5] = props;
    $[6] = ref;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});
DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;
const DropdownMenuShortcut = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("ml-auto text-xs tracking-widest opacity-60", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = /*#__PURE__*/_jsx("span", {
      className: t1,
      ...props
    });
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
DropdownMenuShortcut.displayName = "DropdownMenuShortcut";
export { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuShortcut, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger };